import { formatDisplayNumber } from "../../../../../../utility/utils";
import { formatPalletLabel } from "../../helpers/formatPallet";

const formatLineasPallets = (pallets) => {
    return pallets.map((item) => {
        const etiqueta = formatPalletLabel(
            item.pallet_numero,
            item.identificador_fisico,
        );

        return `${etiqueta}: ${formatDisplayNumber(item.pacas)} pacas`;
    });
};

const formatLineasSobrante = (sobrante) => {
    return sobrante.map((item) => {
        return `${item.producto_nombre}: ${formatDisplayNumber(item.kg_secos, 2)} kg`;
    });
};

// Texto para el title de las celdas de kg: de qué pallets se tomaron las pacas
// y cuántas de cada uno, o de qué productos salió el sobrante y cuántos kg de
// cada uno
export const formatDetalleReproceso = (detalle) => {
    if (!detalle) return null;

    let lineas = [];

    if (detalle.pallets && detalle.pallets.length > 0) {
        lineas = lineas.concat(
            "Pacas de reproceso:",
            formatLineasPallets(detalle.pallets),
        );
    }

    if (detalle.sobrante && detalle.sobrante.length > 0) {
        lineas = lineas.concat(
            "Sobrante de reproceso:",
            formatLineasSobrante(detalle.sobrante),
        );
    }

    if (lineas.length === 0) return null;

    return lineas.join("\n");
};

// Une el detalle de las cargas agrupadas por almacén, sumando las pacas de un
// mismo pallet y los kg de un mismo producto
export const unirDetallesReproceso = (cargas) => {
    const pallets = {};
    const sobrante = {};

    (cargas || []).forEach((carga) => {
        const detalle = carga.detalle_reproceso;

        if (!detalle) return;

        (detalle.pallets || []).forEach((item) => {
            if (!pallets[item.pallet_numero]) {
                pallets[item.pallet_numero] = { ...item, pacas: 0 };
            }

            pallets[item.pallet_numero].pacas += Number(item.pacas || 0);
        });

        (detalle.sobrante || []).forEach((item) => {
            if (!sobrante[item.producto_nombre]) {
                sobrante[item.producto_nombre] = { ...item, kg_secos: 0 };
            }

            sobrante[item.producto_nombre].kg_secos += Number(
                item.kg_secos || 0,
            );
        });
    });

    return {
        pallets: Object.values(pallets),
        sobrante: Object.values(sobrante),
    };
};
